export function teamSlider() {

	if ($(".team_slider__js").length > 0) {

		// if ( $(window).width() <= '968' &&  $(window).width() > '540') {
		$('.team_slider__js').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: true,
			dots: true,
			appendDots: $('.team__js'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				},
			]
		});
	}
}